import { DatePicker as IdskDatePicker } from '@mc-ui/idsk-react-components';

import { withReactHookFormControlled } from '../hoc/withReactHookFormControlled';

export const DatePicker = withReactHookFormControlled(IdskDatePicker);
